module.exports = __webpack_public_path__ + "static/media/hand-saw.b34ba4eb.svg";